import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { kcc20MockInterceptor } from './mocks/kcc20-mock.interceptor';
import { kcc20ApiDiagnosticsInterceptor } from './services/diagnostics/kcc20-api-diagnostics.interceptor';
import { Kcc20ClientErrorHandler } from './services/diagnostics/kcc20-client-error-reporter.service';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: Kcc20ClientErrorHandler },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    // kcc20MockInterceptor is a no-op unless environment.useMockData is set
    // (the `mock` build config); it never affects dev/prod builds.
    provideHttpClient(
      withFetch(),
      withInterceptors([kcc20MockInterceptor, kcc20ApiDiagnosticsInterceptor]),
    ),
  ],
};
